import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import FormSwitch from '@/components/form/formSwitch'

// eslint-disable-next-line react-refresh/only-export-components
export const itchConnectionSchema = z.object({
    createItchConnection: z.boolean(),
})

type ItchConnectionSchemaType = z.infer<typeof itchConnectionSchema>

interface Props {
    form: UseFormReturn<ItchConnectionSchemaType>
    className?: string | undefined
}

export default function CreateMarketItchConnectionForm({ form, className }: Props) {
    return (
        <FormSwitch
            control={form.control}
            name="createItchConnection"
            label="Create a ITCH connection on market creation"
            className={className}
        />
    )
}
